import { useQuery } from '@apollo/client'
import cloneDeep from 'lodash.clonedeep'
import { useState, useEffect, useRef } from 'react'
import { FormTypes } from '../constants/form'
import { Capitalization, CapitalizationVariables } from '../queries/Capitalization'
import { CAPITALIZE } from '../queries/CapitalizeCitation'
import { getCitationTitle, replaceCitationTitle } from '../utils/citations'

export const useCapitalization = (formType: string, citation) => {
  const [capitalized, setCapitalized] = useState<boolean>(false)
  const capitalizationRequired: boolean =
    (formType === FormTypes.NEW || formType === FormTypes.MANUAL) && !!citation

  const title = citation ? getCitationTitle(citation) : ''

  const { data, loading } = useQuery<Capitalization, CapitalizationVariables>(
    CAPITALIZE,
    {
      variables: {
        citationsInput: [title],
      },
      ssr: false,
      skip: !capitalizationRequired || capitalized,
    }
  )

  useEffect(() => {
    if (!loading && data && !capitalized) {
      setCapitalized(true)
    }
  }, [data])

  useEffect(() => {
    if (capitalized) {
      setCapitalized(false)
    }
  }, [citation])

  const modifiedCitationRef = useRef(cloneDeep(citation))

  if (data) {
    modifiedCitationRef.current = cloneDeep(citation)
    replaceCitationTitle(
      modifiedCitationRef.current,
      data?.capitalization.citations[0] || title
    )
  }

  return {
    citationWithCapitalizedTitle: modifiedCitationRef.current,
    capitalizationDone: capitalized,
    capitalizationRequired,
  }
}
